import "./styles.less";

import React, { ReactNode, useContext, useEffect, useState } from "react";

import { LastSearchCard } from "../../../../Components/SEO/LastSearchCard/web";
import { PropComponentMode } from "../../../../Components/Property/PropertyInterfaces";
import { PropertyCardSkeleton } from "shared-components/Components/Property/PropertyCard/PropertyCardSkeleton";
import { fetchSearchResults } from "src/services/search";
import { ListingCard } from "shared-components/ViewFragments/SearchPage/ListingCard";
import usePropertyData from "src/hooks/propertyData/usePropertyData";
import { ConfigStateContext } from "shared-components/Contexts/Configurations/context";
import { EmblaCarousel } from "src/Components/EmblaCarousel";
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";
import { PropertyData } from "src/contexts/PropertyData/PropertyDataProvider";

export function PropertySimilarsCards({
	id,
	mode,
	grid = { xs: 1, sm: 1, md: 2, lg: 3, xl: 4, xxl: 4 },
	title = null,
	ownerId = null,
	avoidFetchingSimilars = false,
	initialProperties = []
}: {
	id: string;
	mode: PropComponentMode;
	grid?: { xs: number; sm: number; md: number; lg: number; xl: number; xxl: number };
	title?: ReactNode;
	ownerId?: string;
	avoidFetchingSimilars?: boolean;
	initialProperties?: PropertyData[];
}) {
	const { main_domain } = useContext(ConfigStateContext);
	const { similars, isLoadingSimilars, setIsLoadingSimilars } = usePropertyData();
	const [properties, setProperties] = useState(initialProperties);
	const screen = useBreakpoint()

	useEffect(() => {
		if (avoidFetchingSimilars) return;
		const isProject = mode === "project"


		if (!!similars?.length && !isProject) {
			setProperties(similars)
		} else if (isProject && ownerId) {
			let params = {
				owner_id: ownerId,
				projects: true
			}

			const payload = {
				rows: 10,
				params,
				page: 1,
				source: 10,
			};

			fetchSearchResults(payload, main_domain)
				.then((res: any) => {
					const data = res?.searchFast?.data
					const exludeCurrentProject = data.filter((item) => item.project.id !== id)

					if (setIsLoadingSimilars) setIsLoadingSimilars(false)
					setProperties(exludeCurrentProject)
				})
		}
	}, [similars, ownerId]);

	if (!properties?.length) return null;

	return (
		<>
			{title ? (
				<h4 className="subhead subhead-semibold high similars-title">{title}</h4>
			) : (
				<h4 className="subhead subhead-semibold high similars-title">Propiedades Similares</h4>
			)}

			<EmblaCarousel 
				options={{
					slidesPerView: screen.md ? 4 : screen.sm ? 2 : screen.xs ? 1 : 4,
					navigation: true,
					slidesToScroll: 1,
					align:'center',
					breakpoints: {
						'(min-width:768px)':{ slidesToScroll: 4, align:'start', }
					}
				}}
				className="property-similars-cards"
				totalSlides={!!properties.length ? properties.length : 4}
				title="propiedades-similares-detalle"
			>
				{isLoadingSimilars ?
					[...Array(4)].map((property, i) => {
						return (
							<div key={"similard_card_" + i} className={"similar"}>
								<PropertyCardSkeleton />
							</div>
						);
					}) :
					properties.map((property, i) => {
						return (
							<div key={"similard_card_" + i} className={"similar"}>
								<ListingCard shortCard={true} data={property} preloadImg={i < 3} hideCta staticGallery showExpenses={property.commonExpenses?.amount > 0} />
							</div>
						);
					})
				}

				{!isLoadingSimilars && (
					<div key={"similard_card_" + properties.length + 1} className="similar more-properties">
						<LastSearchCard />
					</div>
				)}
			</EmblaCarousel>
		</>
	);
}

export const getBreakpointNumber = bp => {
	return Number(bp.substring(0, bp.length - 2));
};
